import type { MilkdownPlugin } from "@milkdown/kit/ctx";

import { toggleSuperscriptCommand } from "../mark";

/// @internal
export const commands: MilkdownPlugin[] = [toggleSuperscriptCommand];
